<template>
  <div class="app-container">
    <list ref="list">
      <template slot="toolbar-right" v-if="$permission.canWrite()">
        <el-button type="primary" @click="create" icon="el-icon-plus"
          >添加</el-button
        >
        <el-button type="danger" @click="delRows">删除</el-button>
      </template>
      <template slot="column">
        <el-table-column label="操作" fixed="right" align="center" width="160">
          <template slot-scope="{ row }">
            <template v-if="row.Status < 2">
              <template v-if="$permission.canWrite()">
                <el-button type="text" @click.stop="edit(row)"
                  >编辑</el-button
                >
              </template>
              <!-- <template v-if="$permission.canReview()">
                <el-button type="text" @click.stop="review(row.OtherPayId)">审核</el-button>
              </template> -->
            </template>
            <el-button type="text" v-else @click.stop="details(row)"
              >查看</el-button
            >
          </template>
        </el-table-column>
      </template>
    </list>
    <edit-dialog ref="editDialog" @close-saved="reload" />
  </div>
</template>
<script>
import curdMixins from "@/mixins/trend/curd";
import list from "@/components/finance/dealings/othereceive/list";
import editDialog from "@/components/finance/dealings/othereceive/editDialog";

export default {
  name: "othereceice",
  mixins: [curdMixins],
  components: {
    list,
    editDialog,
  },

  methods: {
    // create(){
    //   this.$refs.editDialog.openCreate()
    // },
    // edit(){
    //   this.$refs.editDialog.openEdit()
    // },
    create() {
      this.$router.push({
        name: "editOthereceive",
        params: { mode: "create" },
      });
    },
    edit(data) {
      this.$router.push({
        name: "editOthereceive",
        params: { mode: "edit", data },
      });
    },
    details(data) {
      this.$router.push({
        name: "editOthereceive",
        params: { mode: "details", data },
      });
    },
    editById(id) {
      this.$router.push({
        name: "editOthereceive",
        params: { mode: "editById", rowId: id },
      });
    },
    delRows() {
      let rows = this.$refs.list.getCheckedRows();
      if (rows.length == 0) {
        this.$message.warning("请选择要删除的数据");
        return;
      }
      this.$confirm("确认删除所选的数据吗？", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning",
      })
        .then(() => {
          let ids = rows.map((item) => {
            return item.OtherReceivId;
          });
          this.$refs.list.delRange(ids);
        })
        .catch(() => {});
    },
  },
};
</script>
